
export const EXAMPLE_IMAGES = [
    'benbenn.jpg',
    'cezanne2.jpg',
    'colorroses.jpg',
    'colorswirls.jpg',
    'coolcar.jpg',
    'darkbrewery.jpg',
    'dhuku.jpg',
    'greentruck.jpg',
    'frida.jpg',
    'homer.jpg',
    'keyssunset.jpg',
    'lobsterpot.jpg',
    'myersflat.jpg',
    'myrtle.jpg',
    'parrot.jpg',
    'redrose.jpg',
    'robert_s_duncanson.jpg',
    'seurat.jpg',
    'vangogh.jpg',
];

